export default __webpack_public_path__ + "static/media/HN.4897feae.ico";